<template>
  <div class="tr-right-col">
    <!-- Summary Compliane -->
    <div class="tr-summary__compliance-container">
      <div class="summmary-head">Summary Compliance</div>
      <div class="summary-items-wrap">
        <div class="summary-item">
          <span class="summary-label">WFR (openable)% :</span>
          <span v-if="$route.name !== 'OverallResult'" class="summary-value" :class="{ '--invalid': step4.wfropObj.wfropPercent < step4.wfropObj.minWfropPercent }">{{ step4.wfropObj.wfropPercent || 0 }}</span>
          <span v-if="$route.name == 'OverallResult'" class="summary-value">{{ '----' }}</span>
        </div>
        <div class="summary-item">
          <span class="summary-label">VLT (recommended):</span>
          <span v-if="$route.name !== 'OverallResult'" class="summary-value">{{ step4.vltObj.required_vlt }}</span>
          <span v-if="$route.name == 'OverallResult'" class="summary-value">{{ '----' }}</span>
        </div>
        <div class="summary-item">
          <span class="summary-label">Uroof (W/m<sup>2</sup>.K):</span>
          <span v-if="$route.name !== 'OverallResult'" class="summary-value" :class="{ '--invalid': step5A.roof_u_value > 1.2 }">{{ step5A.roof_u_value }}</span>
          <span v-if="$route.name == 'OverallResult'" class="summary-value">{{ '----' }}</span>
        </div>
        <div class="summary-item">
          <span class="summary-label">RETV (W/m<sup>2</sup>):</span>
          <span v-if="$route.name !== 'OverallResult'" class="summary-value" :class="{ '--invalid': retv6C.retv > 15 }">{{ retv6C.retv || 0 }}</span>
          <span v-if="$route.name == 'OverallResult'" class="summary-value">{{ '----' }}</span>
        </div>
      </div>
    </div>
    <!-- Help Docs Container -->
    <div class="tr-help-docs__wrap">
      <div class="tr-help-doc__container">
        <div class="tr-right-col__tabs-wrap">
          <div class="tr-help__tab" :class="{ '--active': activeTab === 'Help' }" @click="activeTab = 'Help'"><v-icon>mdi-help-circle</v-icon><span>Help</span></div>
          <div class="tr-notes__tab" :class="{ '--active': activeTab === 'Notes' }" @click="activeTab = 'Notes'"><v-icon>mdi-notebook-edit</v-icon> <span>Notes</span></div>
        </div>
        <div class="active-tab__content-wrap">
          <div class="active-tab__content" v-if="activeTab === 'Help'">HELP DOCS</div>
          <div v-if="activeTab === 'Notes'">NOTES</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeTab: 'Help',
    };
  },
  computed: {
    schema: {
      get: function() {
        return this.$store.state.schema;
      },
      set: function(newSchema) {
        this.$store.dispatch('setSchema', newSchema);
      },
    },
    step5A: {
      get: function() {
        return this.$store.state.schema.inputs.step5A;
      },
      set: function(step5A) {
        this.$store.dispatch('setStep5A', step5A);
      },
    },
    step4: {
      get: function() {
        return this.$store.state.schema.inputs.step4;
      },
      set: function(step4) {
        this.$store.dispatch('setStep4', step4);
      },
    },
    retv6C: {
      get: function() {
        return this.$store.state.schema.inputs.retv6C;
      },
      set: function(retv6C) {
        this.$store.dispatch('setRetv6C', retv6C);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.tr-right-col {
  padding: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #5a6978;
  color: #fff;
  width: 100%;
  height: 100vh;
  // .tr-right-col__head {
  //   text-align: center;
  //   padding: 12px;
  //   color: #ffffff;
  //   font-size: 32px;
  //   font-weight: 360;

  //   line-height: 50px;
  //   //   text-align: left;
  // }
}
.tr-summary__compliance-container {
  margin-top: 48px;
  background-color: #fff;
  color: #343f4b;
  border-radius: 4px;
  width: 88%;

  height: 50%;
  .summmary-head {
    padding: 6px;
    text-align: center;
    font-size: 20px;
    font-weight: 400;
    background-color: #dedede;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
  }
}

.summary-items-wrap {
  display: flex;
  flex-direction: column;
  .summary-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px;
    border-bottom: 1px solid #dedede;
    width: 100%;
    .summary-value {
      width: 30%;
      text-align: center;
      padding: 4px;
      background-color: #c8f0e0;
      color: #2cb17c;
      border-radius: 4px;
    }
    .--invalid {
      background-color: #ffebeb;
      color: #ff6767;
    }
  }
}

.tr-help-docs__wrap {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}
.tr-help-doc__container {
  background-color: #fff;
  color: #343f4b;
  border-radius: 4px;
  width: 88%;
  height: 90%;
}
.tr-right-col__tabs-wrap {
  display: flex;
  width: 100%;

  .tr-help__tab,
  .tr-notes__tab {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 50%;
    padding: 8px;
    font-size: 18px;
    background-color: #ededed;
    color: #343f4b;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    cursor: pointer;
    span {
      margin-left: 12px;
    }
    &.--active {
      background-color: #dedede;
    }
  }
}
.active-tab__content-wrap {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>
